// import axios from 'axios';
// import { APIV2 } from '../../../backend';
// import { useAppContext } from '../../../hooks/context/AppContext';
// import { useState, useMemo } from 'react';
// import useSilentIdTokenRefresh from "../../../msal/useSilentTokenRefresh";

// // Common error handler
// const handleError = (error: unknown, context: string) => {
//   console.error(`Error ${context}:`, error);
//   return null;
// };

// // Copy Project Interface
// export interface CopyProject {
//   projectName: string;
//   projectId: string;
//   imageName: string;
//   countryKey: number;
//   createdBy: string;
// };

// // Custom hook for API client
// export const useApiClient = () => {
//   const { authData } = useAppContext();
//   const [idToken, setIdToken] = useState(null);
//   const getIdTokenSilently = useSilentIdTokenRefresh((token: any | null, account: any | null) => {
//     setIdToken(token)
//   });  

//   const apiClient = useMemo(() => {
//     const instance = axios.create({
//       baseURL: APIV2,
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: idToken ? `Bearer ${idToken}` : `Bearer ${authData.idToken}`,
//       },
//     });

//     return instance;
//   }, [idToken, authData.idToken]);

//   // Copy Project API
//   const createCopyProject = async (payload: CopyProject) => {
//     try {
//       const response = await apiClient.post('/projects/copy', payload);
//       return response.data;
//     } catch (err) {
//       return handleError(err, 'creating copy project');
//     }
//   };

//   return {
//     createCopyProject,
//   };
// };


import axios from 'axios';
import { APIV2 } from '../../../backend';
import { useAppContext } from '../../../hooks/context/AppContext';
import { useState, useMemo } from 'react';
import useSilentIdTokenRefresh from "../../../msal/useSilentTokenRefresh";

// Common error handler
const handleError = (error: unknown, context: string) => {
  console.error(`Error ${context}:`, error);
  return null;
};

// Copy Project Interface
export interface CopyProject {
  projectName: string;
  projectId: string;
  imageName: string;
  countryKey: number;
  createdBy: string;
};

// Custom hook for API client
export const useApiClient = () => {
  const { authData } = useAppContext();
  const [idToken, setIdToken] = useState(null);
  const getIdTokenSilently = useSilentIdTokenRefresh((token: any | null, account: any | null) => {
    setIdToken(token)
  });

  const apiClient = useMemo(() => {
    const instance = axios.create({
      baseURL: APIV2,
      headers: {
        'Content-Type': 'application/json',
        Authorization: idToken ? `Bearer ${idToken}` : `Bearer ${authData.idToken}`,
      },
    });

    // Add response interceptor to handle 401 errors
    instance.interceptors.response.use(
      response => response,
      async (error) => {
        const originalRequest = error.config;

        // If the error is 401 and we haven't already retried
        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          try {
            const {token}  = await getIdTokenSilently();
            if (token) {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return instance(originalRequest);
            }
          } catch (refreshError) {
            console.error('Error refreshing token:', refreshError);
            // If token refresh fails, redirect to login or handle as needed
            // You might want to add your auth redirect logic here
            window.location.reload();
            return Promise.reject(refreshError);
          }
        }

        return Promise.reject(error);
      }
    );

    return instance;
  }, [idToken, authData.idToken, getIdTokenSilently]);

  // Copy Project API
  const createCopyProject = async (payload: CopyProject) => {
    try {
      const response = await apiClient.post('/projects/copy', payload);
      return response.data;
    } catch (err) {
      return handleError(err, 'creating copy project');
    }
  };

  return {
    createCopyProject,
  };
};